<template>
  <div class="min-h-screen bg-gray-50">
    <div class="container mx-auto px-4 py-8 max-w-7xl">
      <!-- Header with Welcome and Date -->
      <div class="mb-8 flex flex-col md:flex-row md:items-center md:justify-between">
        <div>
          <h1 class="text-3xl font-bold text-gray-900 flex items-center">
            Welcome back, {{ currentUser.name }}
            <span class="ml-3 text-sm font-normal text-gray-500 bg-white px-3 py-1 rounded-full shadow-sm">
              {{ currentDate }}
            </span>
          </h1>
          <p class="text-lg text-gray-600 mt-1">SMS Reader</p>
        </div>
      </div>

      <!-- Filters Bar -->
      <div class="mb-6 bg-white p-4 rounded-lg shadow-sm border border-gray-100">
        <div class="grid grid-cols-1 md:grid-cols-4 gap-4">
          <!-- Sender filter -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">Sender ID</label>
            <select
              v-model="selectedSender"
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500"
            >
              <option value="">All Senders</option>
              <option v-for="sender in senderOptions" :key="sender" :value="sender">
                {{ sender }}
              </option>
            </select>
          </div>

          <!-- Message search -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">Message contains</label>
            <input
              v-model="searchQuery"
              type="text"
              placeholder="Search in messages..."
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500"
            />
          </div>

          <!-- Date from -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">Date from</label>
            <input
              v-model="dateFrom"
              type="date"
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500"
            />
          </div>

          <!-- Date to -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">Date to</label>
            <input
              v-model="dateTo"
              type="date"
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500"
            />
          </div>
        </div>

        <!-- Clear filters button -->
        <div class="mt-4 flex justify-end">
          <button
            @click="clearFilters"
            class="px-4 py-2 text-sm text-gray-600 bg-gray-100 rounded-md hover:bg-gray-200 transition"
          >
            Clear Filters
          </button>
        </div>
      </div>
      <div> 
        <!-- Customer Information Card -->
            <div
              class="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden"
            >
              <div
                class="px-6 py-4 bg-gradient-to-r from-blue-50 to-purple-50 border-b border-gray-100"
              >
                <h2
                  class="text-lg font-semibold text-gray-900 flex items-center"
                >
                  <svg
                    class="w-5 h-5 mr-2 text-blue-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                    />
                  </svg>
                  Client Information
                </h2>
              </div>
              <div class="p-6">
                <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label
                      class="text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >Full Name</label
                    >
                    <p class="mt-1 text-lg font-medium text-gray-900">
                      {{ client.client_name }}
                    </p>
                  </div>
                  <div>
                    <label
                      class="text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >Gender</label
                    >
                    <p class="mt-1 text-gray-700">
                      {{ client.gender }}
                    </p>
                  </div>
                  <div>
                    <label
                      class="text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >ID Number</label
                    >
                    <p class="mt-1 text-gray-700">
                      {{ client.id_number }}
                    </p>
                  </div>
                  <div>
                    <label
                      class="text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >Date of Birth</label
                    >
                    <p class="mt-1 text-gray-700">
                      {{ formatDateOfBirth(client.dob) }}
                    </p>
                  </div>
                  <div>
                    <label
                      class="text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >Education</label
                    >
                    <p class="mt-1 text-gray-700">
                      {{ client.education }}
                    </p>
                  </div>
               
                 
                  <div>
                    <label
                      class="text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >Phone Number</label
                    >
                    <p class="mt-1 text-gray-700 flex items-center">
                      {{ formatKenyanPhone(client.client_phone) }}
                      <button
                        @click="
                          copyToClipboard(
                            formatKenyanPhone(client.client_phone)
                          )
                        "
                        class="ml-2 p-1 hover:bg-gray-100 rounded"
                        title="Copy phone number"
                      >
                        <svg
                          class="w-4 h-4 text-gray-400"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
                          />
                        </svg>
                      </button>
                    </p>
                  </div>
                  <div>
                    <label
                      class="text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >Alternative Phone Number</label
                    >
                    <div class="mt-1 text-gray-700 flex items-center">
                      {{ client.alt_phone }}
                      <button
                        @click="copyToClipboard(client.alt_phone)"
                        class="ml-2 p-1 hover:bg-gray-100 rounded"
                        title="Copy phone number"
                      >
                        <svg
                          class="w-4 h-4 text-gray-400"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
                          />
                        </svg>
                      </button>
                      <StatusBadge :status="client.alt_phone_status" />
                    </div>
                  </div>
                 
                </div>
              </div>
            </div>
      </div>
      <div class="flex justify-end mt-4">
          <!-- Complete Verification Action -->
                <button
                  @click="openCompleteModal"
                  class="w-full flex items-center justify-center px-4 py-3 bg-indigo-800 text-white rounded-lg hover:bg-indigo-700 transition-colors"
                  :disabled="isSubmitting"
                >
                  <svg
                    class="w-5 h-5 mr-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                  Complete Verification
                </button>
      </div>

      <!-- SMS Data Display -->
      <div v-if="filteredTickets.length === 0" class="text-center py-8">
        <p class="text-gray-500">No messages match your filters</p>
      </div>
      <div v-else>
        <div
          v-for="ticket in filteredTickets"
          :key="ticket.id"
          class="mb-6 bg-gray-50 p-4 rounded-lg border"
        >
          <h3 class="font-semibold text-indigo-800 mb-3">
            Sender: {{ ticket.sender_id }} ({{ ticket.messages.length }} messages)
          </h3>

          <ul class="space-y-3">
            <li
              v-for="(msg, idx) in ticket.messages"
              :key="idx"
              class="bg-white p-3 rounded border"
            >
              <p class="text-gray-800">{{ msg.message }}</p>
              <p class="text-xs text-gray-500 mt-2">
                {{ formatDate(msg.date_received) }}
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="container mx-auto px-4 py-8 max-w-7xl">
        <div class="grid grid-cols-1 md:grid-cols-4 gap-4">
            <div class="col-span-1 md:col-span-4">
                <h2 class="text-2xl font-bold text-gray-900">Approval</h2>
            </div>
        </div>
    </div>

    <!-- Floating Action Button (Refresh) -->
    <button
      @click="refreshData"
      class="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-indigo-800 text-white shadow-lg transition-all duration-300 hover:bg-indigo-700 hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
      aria-label="Refresh page"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-6 w-6"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        :class="{ 'animate-spin': isRefreshing }"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
        />
      </svg>
    </button>

    <!-- Loading Overlay -->
    <div
      v-if="isRefreshing"
      class="fixed inset-0 ml-64 bg-white/80 backdrop-blur-sm flex items-center justify-center z-50"
    >
      <div class="relative">
        <div class="w-16 h-16 border-4 border-gray-200 rounded-full"></div>
        <div
          class="w-16 h-16 border-4 border-transparent rounded-full absolute top-0 left-0 border-t-indigo-500 border-r-indigo-700 animate-spin"
        ></div>
        <div
          class="w-3 h-3 bg-indigo-800 rounded-full absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
        ></div>
      </div>
    </div>
  </div>


      <!-- Complete Verification Modal -->
      <div v-if="showCompleteModal" class="fixed inset-0 z-50 overflow-y-auto">
        <div
          class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
        >
          <div
            class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
            @click="closeCompleteModal"
          ></div>

          <div
            class="inline-block align-bottom bg-white rounded-xl text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full"
          >
            <div class="bg-white px-6 pt-5 pb-4 sm:p-6">
              <h3 class="text-lg font-semibold text-gray-900 mb-4">
                Complete Verification - {{ route.params.id}}
              </h3>

              <form @submit.prevent="submitCompletion">
                <!-- Final Decision -->
                <div class="mb-4">
                  <label class="block text-sm font-medium text-gray-700 mb-2"
                    >Final Decision</label
                  >
                  <select
                    v-model="completionForm.decision"
                    required
                    class="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="">Select decision</option>
                    <option value="Ready">
                      Verified - All information confirmed
                    </option>
                    <option value="Rejected">
                      Rejected - Unable to verify information
                    </option>
                  </select>
                </div>

                 <!-- Final Decision -->
                <div class="mb-4">
                  <label class="block text-sm font-medium text-gray-700 mb-2"
                    >Comment</label
                  >
                  <select
                    v-model="completionForm.comment"
                    required
                    class="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="">Select Comment</option>
                    <option value="0">
                      Defaulter
                    </option>
                    <option value="1">
                      Loan data not found
                    </option>
                    <option value="2">
                      No SMS data found
                    </option>
                    <option value="3">
                      Limited SMS data found
                    </option>
                    <option value="4">
                      Approved
                    </option>
                  </select>
                </div>

                <!-- Summary -->
                <div class="mb-4">
                  <label class="block text-sm font-medium text-gray-700 mb-2"
                    >Summary</label
                  >
                  <textarea
                    v-model="completionForm.summary"
                    required
                    rows="4"
                    class="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Provide a detailed summary of the verification process..."
                  ></textarea>
                </div>

                <!-- Submit Buttons -->
                <div class="mt-6 flex justify-end space-x-3">
                  <button
                    type="button"
                    @click="closeCompleteModal"
                    class="px-4 py-2 text-red-400 border border-red-400 rounded-lg"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    class="px-4 py-2 bg-indigo-800 text-white rounded-lg hover:bg-indigo-700"
                    :disabled="isSubmitting"
                  >
                    {{
                      isSubmitting ? "Submitting..." : "Complete Verification"
                    }}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
<!-- Success Notification -->
      <div
        v-if="showNotification"
        class="fixed bottom-4 right-4 bg-green-500 text-white px-6 py-3 rounded-lg shadow-lg flex items-center space-x-3 animate-slide-up z-50"
      >
        <svg
          class="w-5 h-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
        <span>{{ notificationMessage }}</span>
      </div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useAuthStore } from "@/stores/authStore";
import api from "@/utils/api";
import { useNotifications } from "@/composables/useNotifications";
import { useRoute } from "vue-router";

const route = useRoute();
const smsData = ref([]); // Array of ticket objects
const { showError, formatValidationErrors } = useNotifications();
const authStore = useAuthStore();

const isSubmitting = ref(false);
const showNotification = ref(false);
const notificationMessage = ref("");
const client = ref(null);

// User state
const currentUser = ref({});
const isRefreshing = ref(false);

const showCompleteModal = ref(false);

if (authStore.isAuthenticated) {
  currentUser.value = authStore.user;
}

// Date display
const currentDate = computed(() => {
  return new Date().toLocaleDateString("en-US", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });
});

// ---------- Filters ----------
const selectedSender = ref("");
const searchQuery = ref("");
const dateFrom = ref("");
const dateTo = ref("");

const completionForm = ref({
  decision: "",
  summary: "",
});

// Unique sender IDs from loaded tickets
const senderOptions = computed(() => {
  if (!smsData.value.length) return [];
  const senders = new Set(smsData.value.map((ticket) => ticket.sender_id).filter(Boolean));
  return Array.from(senders).sort();
});

// Helper to format timestamp (ms) to YYYY-MM-DD for date comparison
const getDateOnly = (timestamp) => {
  const date = new Date(timestamp);
  return date.toISOString().split("T")[0];
};

// Filtered tickets (applies all three filters)
const filteredTickets = computed(() => {
  if (!smsData.value.length) return [];

  return smsData.value
    .filter((ticket) => {
      // 1. Filter by sender ID
      if (selectedSender.value && ticket.sender_id !== selectedSender.value) return false;
      return true;
    })
    .map((ticket) => {
      // 2. Filter messages by search query and date range
      const filteredMessages = ticket.messages.filter((msg) => {
        // Search query (case-insensitive)
        if (searchQuery.value && 
    (!msg.message || 
     !msg.message.toLowerCase().includes(searchQuery.value.toLowerCase()))) {
    return false;
}
        // Date from
        if (dateFrom.value) {
          const msgDate = getDateOnly(msg.date_received);
          if (msgDate < dateFrom.value) return false;
        }
        // Date to
        if (dateTo.value) {
          const msgDate = getDateOnly(msg.date_received);
          if (msgDate > dateTo.value) return false;
        }
        return true;
      });

      // Return ticket with only matching messages
      return { ...ticket, messages: filteredMessages };
    })
    .filter((ticket) => ticket.messages.length > 0); // remove tickets with no matching messages
});

// Clear all filters
const clearFilters = () => {
  selectedSender.value = "";
  searchQuery.value = "";
  dateFrom.value = "";
  dateTo.value = "";
};

// Format timestamp to readable string
const formatDate = (timestamp) => {
  return new Date(timestamp).toLocaleString();
};

// ---------- Data fetching ----------
const fetchSmsData = async () => {
  try {
    const response = await api.get(`/api/v1/tickets/sms/${route.params.id}`);
    smsData.value = response.data.messages; // array of tickets
  } catch (error) {
    console.error(error);
    const details = formatValidationErrors(error);
    showError("Error", "Failed to load SMS data", details, 5000);
  }
};

const refreshData = async () => {
  isRefreshing.value = true;
  try {
    await fetchSmsData();
    // Optionally reset filters after refresh
    clearFilters();
  } catch (error) {
    console.log(error);
  } finally {
    isRefreshing.value = false;
  }
};

// Completion handlers
const openCompleteModal = () => {
  completionForm.value = {
    decision: "",
    summary: "",
  };
  showCompleteModal.value = true;
};

const closeCompleteModal = () => {
  showCompleteModal.value = false;
};

const submitCompletion = async () => {
  isSubmitting.value = true;

  try {
    const response = await api.post(
      `/api/v1/tickets/${route.params.id}/completion/sms`,
      completionForm.value
    );
    console.log(response);

    closeCompleteModal();
    showNotificationMessage("Ticket completed successfully");
    
  } catch (error) {
    console.log(error);
    const details = formatValidationErrors(error);
    showError("Error", "Failed to complete ticket!", details, 5000);
  } finally {
    isSubmitting.value = false;
  }
};

// Notification helper
const showNotificationMessage = (message) => {
  notificationMessage.value = message;
  showNotification.value = true;
  setTimeout(() => {
    showNotification.value = false;
  }, 3000);
};


// Fetch ticket data
const fetchTicketClient = async () => {
  isRefreshing.value = true;
  try {
    const response = await api.get(`/api/v1/ticket/get/${route.params.id}`);
    client.value = response.data || [];

  } catch (error) {
    console.log(error);
    const details = formatValidationErrors(error);
    showError("Error", "Failed to load tickets", details, 5000);
  } finally {
    isRefreshing.value = false;
  }
};

const formatDateOfBirth = (dateString) => {
  if (!dateString) return "N/A";
  try {
    const date = new Date(dateString);
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const day = date.getDate();
    const suffix =
      day >= 11 && day <= 13
        ? "th"
        : ["st", "nd", "rd"][(day % 10) - 1] || "th";

    return `${day}${suffix} ${months[date.getMonth()]} ${date.getFullYear()}`;
  } catch (error) {
    console.log(error);
    return "N/A";
  }
};

const formatKenyanPhone = (phoneNumber) => {
  if (!phoneNumber) return "N/A";

  try {
    // Convert to string and remove any non-digit characters
    const cleaned = String(phoneNumber).replace(/\D/g, "");

    // Check if it's a Kenyan number starting with 254
    if (cleaned.startsWith("254")) {
      // Remove '254' and ensure we have the remaining 9 digits
      const localNumber = cleaned.substring(3);

      // If we have exactly 9 digits after removing 254, format with leading 0
      if (localNumber.length === 9) {
        return "0" + localNumber;
      }
      // If we have 12 digits total (254 + 9 digits), take the last 9
      else if (cleaned.length === 12) {
        return "0" + cleaned.slice(-9);
      }
    }

    // Return original cleaned number if not in Kenyan format
    return cleaned;
  } catch (error) {
    console.log(error);
    return "N/A";
  }
};

onMounted(() => {
  refreshData(); // calls fetch + clears filters
  fetchTicketClient();
});
</script>